import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./assets/css/Header.css"

import NotFoundPage from "./404Page";
import ErrorBoundary from "./ErrorBoundary";
import LowercaseRedirect from "./LowercaseRedirect";
import Home from "./home";
import School from "./school-components/School";
import SchoolV2 from "./school-components/SchoolV2";
import SchoolV3 from "./school-components/SchoolV3";
import SchoolV4 from "./school-components/SchoolV4";
import Management from "./schools/Management";
import IT from "./schools/IT";
import HotelManagement from "./schools/HotelManagement";

const App = () => {
  const [isRootEmpty, setIsRootEmpty] = useState(false);

  useEffect(() => {
    const rootDiv = document.getElementById("root");
    if (!rootDiv || rootDiv.innerHTML.trim() === "") {
      setIsRootEmpty(true);
    }
  }, []);

  if (isRootEmpty) {
    return <Navigate to="/404" replace />;
  }

  return (
    <Router>
      <ErrorBoundary>
        {/* Redirect to lowercase if needed */}
        <LowercaseRedirect />
        <Routes>
          {/* Default route */}
          <Route path="/" element={<Home />} />
          {/* Aliases for home */}
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/school" element={<School />} />
          <Route path="/school-2" element={<SchoolV2 />} />
          <Route path="/school-3" element={<SchoolV3 />} />
          <Route path="/school-4" element={<SchoolV4 />} />

          {/* Schools */}
          <Route path="/school/management" element={<Management />} />
          <Route path="/school/information-and-technology" element={<IT />} />
          <Route path="/school/hotel-management" element={<HotelManagement />} />


          {/* 404 Handling */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </ErrorBoundary>
    </Router>
  );
};

export default App;